import http from 'api/httpClient';

export type CustomerAnalysisRequest = {
  year: string;
  months?: number[];
  filters: Record<string, string[]>;
};

export type MetricsData = {
  customers: number;
  income: string;
  expenses: string;
  cm: string;
  cm_pct: string;
};

export type BucketData = {
  title: string;
  order: number;
  min_pct: number | null;
  max_pct: number | null;
  min_inclusive: boolean;
  max_inclusive: boolean;
  metrics: MetricsData;
};

export type CustomerAnalysisResponse = {
  cards: {
    total: {
      title: string;
      metrics: MetricsData;
    };
    buckets: BucketData[];
  };
};

export interface CustomerTableRow {
  customer_code: string;
  customer_name: string;
  income: number;
  expenses: number;
  cm: number;
  cm_pct: number;
}

export interface CustomerTableResponse {
  total: number;
  items: CustomerTableRow[];
}

export interface CustomerDrilldownRequest extends Record<string, unknown> {
  year: string;
  months?: number[];
  filters: Record<string, string[]>;
  bucket: {
    min_pct: number | null;
    max_pct: number | null;
    min_inclusive: boolean;
    max_inclusive: boolean;
  };
  sort: {
    by: 'income' | 'expenses' | 'cm' | 'cm_pct' | 'customer_name';
    dir: 'asc' | 'desc';
  };
  page: number;
  page_size: number;
}

export async function fetchCustomerAnalysisStats(payload: CustomerAnalysisRequest): Promise<CustomerAnalysisResponse> {
  return http.post('/api/v1/dashboard/customer-analysis/stats', payload);
}

export async function fetchCustomerDrilldown(
  params: CustomerDrilldownRequest
): Promise<CustomerTableResponse> {
  return http.post('/api/v1/dashboard/customer-analysis/customers', params);
}

export interface BranchTableRow {
  ou_code: string;
  branch_name: string;
  income: number;
  expenses: number;
  cm: number;
  cm_pct: number;
}

export interface BranchTableResponse {
  customer_code: string;
  items: BranchTableRow[];
}

export interface CustomerBranchRequest extends Record<string, unknown> {
  year: string;
  months?: number[];
  filters: Record<string, string[]>;
  customer_code: string;
  sort: {
    by: 'income' | 'expenses' | 'cm' | 'cm_pct' | 'ou_code' | 'branch_name';
    dir: 'asc' | 'desc';
  };
  page: number;
  page_size: number;
}

export async function fetchCustomerBranches(
  params: CustomerBranchRequest
): Promise<BranchTableResponse> {
  return http.post('/api/v1/dashboard/customer-analysis/customer-branches', params);
}

export interface CnTableRow {
  cn_number: string;
  income: number;
  expenses: number;
  cm: number;
  cm_pct: number;
}

export interface CnTableResponse {
  customer_code: string;
  ou_code: string;
  total: number;
  items: CnTableRow[];
}

export interface BranchCnRequest extends Record<string, unknown> {
  year: string;
  months?: number[];
  filters: Record<string, string[]>;
  customer_code: string;
  ou_code: string;
  sort: {
    by: 'income' | 'expenses' | 'cm' | 'cm_pct' | 'cn_number';
    dir: 'asc' | 'desc';
  };
  page: number;
  page_size: number;
}

export async function fetchBranchCn(
  params: BranchCnRequest
): Promise<CnTableResponse> {
  return http.post('/api/v1/dashboard/customer-analysis/branch-cn', params);
}
